import { Spin } from 'antd';
import React from 'react';
import Loadable from 'react-loadable';

export default function LoadingPage({
  isLoading,
  timedOut,
}: Loadable.LoadingComponentProps) {
  if (isLoading) return <Spin />;
  if (timedOut) {
    return <Spin />;
  }
  return <Spin />;
}
